export enum AplicationsStatuses {
    /**
     * Создана
     */
    NEW = 'new',

    /**
     * Отправлена АТОЛ
     */
    SEND_ATOL = 'sented_atol',

    /**
     * Возвращена на доработку
     */
    RETURNED_VISION = 'returned_revision',

    /**
     * На согласовании АТОЛ
     */
    WAITING_APPROVAL = 'waiting_approval',

    /**
     *  Согласовано
     */
    APPROVAL = 'approval',

    /**
     * Подписание документов
     */
    FOR_SIGNATURE = 'for_signature',

    /**
     * Оплата счетов
     */
    ON_PAYMENT = 'on_payment',

     /**
     * Оплата счетов
     */
    CONDITIONS_NOT_MET = 'conditions_not_met',

      /**
     * Не выполнены условия соглашения
     */
    REJECTED = 'rejected',
    /**
     * Завершено
     */
    COMPLETED = 'completed'
}

export const AplicationStatusesTranslate: Record<string, string> = {
  [AplicationsStatuses.NEW]: 'Создана',
  [AplicationsStatuses.SEND_ATOL]: 'Отправлена АТОЛ',
  [AplicationsStatuses.RETURNED_VISION]: 'Возвращена на доработку',
  [AplicationsStatuses.WAITING_APPROVAL]: 'На согласовании АТОЛ',
  [AplicationsStatuses.APPROVAL]: 'Согласовано',
  [AplicationsStatuses.FOR_SIGNATURE]: 'Подписание документов',
  [AplicationsStatuses.ON_PAYMENT]: 'Оплата счетов',
  [AplicationsStatuses.REJECTED]: 'Отклонено',
  [AplicationsStatuses.CONDITIONS_NOT_MET]: 'Не выполнены условия соглашения',
  [AplicationsStatuses.COMPLETED]: 'Завершено',
};

export const aplications_statuses = Object.keys(
  AplicationStatusesTranslate,
).map(
  (f: string) => ({ text: AplicationStatusesTranslate[f], value: f }),
);

export enum EventsStatuses {
    /**
     * На согласовании
     */
    WAITING_APPROVAL = 'waiting_approval',

    /**
     * На доработке
     */
    RETURNED_FOR_REVISION = 'returned_for_revision',

    /**
     * Согласовано
     */
    APPROVAL = 'approval',

    /**
     * Завершено
     */
    COMPLETED = 'completed',

    /**
     * Отклонено
     */
    CANCELED = 'canceled',

    /**
     * Новая
     */
    NEW = 'new',

    /**
     * Черновик
     */
    DRAFT = 'draft',
}

export const EventsStatusesTranslate: Record<string, string> = {
  [EventsStatuses.NEW]: 'Требуется согласование',
  [EventsStatuses.WAITING_APPROVAL]: 'На согласовании',
  [EventsStatuses.RETURNED_FOR_REVISION]: 'На доработке',
  [EventsStatuses.COMPLETED]: 'Завершено',
  [EventsStatuses.APPROVAL]: 'Согласовано',
  [EventsStatuses.CANCELED]: 'Отклонено',
  [EventsStatuses.DRAFT]: 'Черновик',
};

export const events_statuses = Object.keys(
  EventsStatusesTranslate,
).map(
  (f: string) => ({ text: EventsStatusesTranslate[f], value: f }),
);

export enum EventsTypes {
    /**
     * Баннерная интернет-реклама
     */
    BANNER_INTERNET = 'banner_internet',

    /**
     * Контекстная интернет-реклама
     */
    CONTEXT_INTERNET = 'context_internet',

    /**
     * Собственные мероприятия
     */
    OWN_EVENTS = 'own_events',

    /**
     * Участие в мероприятиях третьих лиц
     */
    OTHER_EVENTS = 'other_events',

    /**
     * PR-статьи в электронных СМИ
     */
    ELECTRONIC_MEDIA = 'electronic_media',

    /**
     * Реклама на интернет-ресурсах в социальных сетях и ТГ
     */
    SOCIAL_MEDIA = 'social_media',
}

export const EventsTypesTranslate: Record<string, string> = {
  [EventsTypes.BANNER_INTERNET]: 'Баннерная интернет-реклама',
  [EventsTypes.CONTEXT_INTERNET]: 'Контекстная интернет-реклама',
  [EventsTypes.OWN_EVENTS]: 'Собственные мероприятия',
  [EventsTypes.OTHER_EVENTS]: 'Участие в мероприятиях третьих лиц',
  [EventsTypes.ELECTRONIC_MEDIA]: 'PR-статьи в электронных СМИ',
  [EventsTypes.SOCIAL_MEDIA]: 'Реклама на интернет-ресурсах в социальных сетях и ТГ',
};

export const events_types = Object.keys(
  EventsTypesTranslate,
).map(
  (f: string) => ({ text: EventsTypesTranslate[f], value: f }),
);
